import { seoFor } from "@/lib/i18n/keywordPools";
import { createFileRoute } from "@tanstack/react-router";
import ClubsIndex from "@/pages/ClubsIndex";
import { MainLayout } from "@/components/layout/MainLayout";

export const Route = createFileRoute("/clubs/")({
  head: () => ({
    meta: [
      { title: "Football Club Predictions & Betting Tips | Statlign" },
      { name: "keywords", content: seoFor({ topics: ["teams", "footballPredictions"] }).meta },
      { name: "description", content: "Browse Statlign club prediction hubs across Europe's major leagues — form, head-to-head trends and value odds for every upcoming fixture." },
      { property: "og:title", content: "Football Club Predictions & Betting Tips | Statlign" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "Browse Statlign club prediction hubs across Europe's major leagues — form, head-to-head trends and value odds for every upcoming fixture." },
      { name: "twitter:title", content: "Football Club Predictions & Betting Tips | Statlign" },
      { name: "twitter:description", content: "Browse Statlign club prediction hubs across Europe's major leagues — form, head-to-head trends and value odds for every upcoming fixture." },
    ],
  }),
  component: () => (
    <MainLayout>
      <ClubsIndex />
    </MainLayout>
  ),
});
